module.exports = __webpack_public_path__ + "img/copy.da42500b.svg";